import React from "react";
import productsData from "../../assets/data/productsData.json";
import { Link } from "react-router-dom";

function MainWid() {
  const importImage = (imageName) => {
    try {
      return require(`../../assets/img/project/${imageName}`);
    } catch (error) {
      console.error("Failed to load image:", imageName);
    }
  };

  return (
    <section className="inner-project-area pt-115 pb-90">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center mb-60">
              <span className="sub-title">Co nabízíme</span>
              <h2 className="title">Prohlédněte si náš sortiment</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          {productsData.map((product, index) => (
            <div key={index} className="col-lg-12 mb-4">
              <div className="services-widget">
                <h4 className="widget-title">{product.title}</h4>
                <div className="our-services-list">
                  <ul className="list-wrap">
                    {product.products.map((subProduct, subIndex) => (
                      <li key={subIndex}>
                        <Link
                          to={`/products/${product.detailLink}/${subProduct.productLink}`}
                        >
                          {subProduct.subTitle}
                          <i className="fas fa-arrow-right"></i>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MainWid;
